import { queryOptions } from '@tanstack/react-query'

import { messagingApi } from './messaging.api'

export const messagingQueryKeys = {
  all: ['messaging'] as const,
  conversations: () => [...messagingQueryKeys.all, 'conversations'] as const,
  unreadCount: () => [...messagingQueryKeys.all, 'unread-count'] as const,
}

export const messagingQueries = {
  conversations: () =>
    queryOptions({
      queryKey: messagingQueryKeys.conversations(),
      queryFn: () => messagingApi.getConversations(),
      // The list keeps itself fresh while visible, like the iOS 15s poll.
      refetchInterval: 15_000,
    }),

  unreadCount: () =>
    queryOptions({
      queryKey: messagingQueryKeys.unreadCount(),
      queryFn: () => messagingApi.getUnreadCount(),
      refetchInterval: 30_000,
    }),
}
